import { useEffect, useState } from 'react';
import { PageBody } from '../../../elements/page-body';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpClient } from '../../../shared/http-client';
import { toast } from 'react-toastify';
import { RoutesConfigForm } from './routes-config-form';


export const RoutesConfigEdit = () => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const navigate = useNavigate();
    const { id } = useParams();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    useEffect(() => {
        if (id) {
            api(`/fleet/route-configs/${id}/`, 'GET');
        }
    }, [id]);

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('/fleet/route-configs/')) {
                if (state.method === 'GET') {
                    setData(state.data);
                }
            }
        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);

    return (
        <>
            <div className="pt-8 pl-8 cursor-pointer" onClick={() => navigate(-1)}>
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <PageBody /* title={'common.label.transporte'} */>
                <>
                    <RoutesConfigForm isEdit={true} item={data} />
                </>
            </PageBody>
        </>
    );
};